<!-- tab filter -->
<div class="row">
  <section class="standards-tabs">
    <div class="tab-wrapper" [class.active]="allStandardsTabCheck">
      <span>
        <img src="/assets/images/list 1.svg" style="margin-right: 8px" height="16" width="16" />
      </span>
      <mat-checkbox class="tabCheckbox" [color]="tabColor" (change)="tabClick($event)" name="allStandards"
        [checked]="setAllStandardsCheck()" [(ngModel)]="allStandardsTabCheck">All Standards</mat-checkbox>
    </div>
    <div class="tab-wrapper" [class.active]="buildingtabcheck">
      <span>
        <img src="/assets/images/building-standrad.svg" style="margin-right: 8px" height="16" width="16" />
      </span>
      <mat-checkbox class="tabCheckbox" [color]="tabColor" (change)="tabClick($event)" name="building"
        [checked]="setBuildingCheck()" [(ngModel)]="buildingtabcheck">Building Standards</mat-checkbox>
    </div>

    <div class="tab-wrapper" [class.active]="operationstabcheck">
      <span>
        <img src="/assets/images/operation-standard.svg" style="margin-right: 8px" height="16" width="16" />
      </span>
      <mat-checkbox name="operations" class="tabCheckbox" [color]="tabColor" (change)="tabClick($event)"
        [checked]="setOperationsCheck()" [(ngModel)]="operationstabcheck">Operations Standards</mat-checkbox>
    </div>

    <!-- <div class="tab-wrapper" [class.active]="equipmenttabcheck">
      <mat-checkbox
        name="equipment"
        [color]="tabColor"
        class="tabCheckbox"
        (change)="tabClick($event)"
        [checked]="setEquipmentCheck()"
        [(ngModel)]="equipmenttabcheck"
        >Equipment Standards*</mat-checkbox
      >
    </div> -->

    <div class="tab-wrapper" [class.active]="globaltabcheck">
      <span>
        <img src="/assets/images/global approved icon.svg" style="margin-right: 8px" height="16" width="16" />
      </span>
      <mat-checkbox name="global" [color]="tabColor" class="tabCheckbox" (change)="tabClick($event)"
        [checked]="setGlobalCheck()" [(ngModel)]="globaltabcheck">Global Approved Solutions</mat-checkbox>
    </div>

    <div class="tab-wrapper" [class.active]="markettabcheck" *ngIf="showMarketStandardsTab()">
      <span>
        <img src="/assets/images/shop-pin 1.svg" style="margin-right: 8px" height="16" width="16" />
      </span>
      <mat-checkbox name="market" [color]="tabColor" class="tabCheckbox" (change)="tabClick($event)"
        [checked]="setMarketCheck()" [(ngModel)]="markettabcheck">Market Standards</mat-checkbox>
    </div>
  </section>
</div>

<!-- <div
  style="
    margin-bottom: 8px;
    background: rgba(128, 128, 128, 0.367);
    width: auto;
    font-weight: 400;
  "
>
  *Equipment Standards is an independent view.
</div> -->

<div style="display: flex; align-items: center;gap:20px">

  <!-- search filter  -->
  <div class="row" style="display: inline-block">
    <div class="mcd-filter-dropdown-wrapper search-wrapper">
      <div class="mcd-search-header">
        <mat-icon class="search-icon">search</mat-icon>
        <input
          type="text"
          placeholder="Type to search..."
          class="search-input-field"
          value="{{ searchKeyFromParent }}"
          (keyup.enter)="onSearch(key)"
          (input)="(0)"
          (keyup)="(0)"
          #key
        />
        <button
          type="button"
          class="clear-button"
          *ngIf="key.value || searchKeyFromParent"
          (click)="key.value = ''; onSearch(key)"
        >
          <mat-icon class="clear-icon">close</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- Category filter -->
  <div *ngIf="
      !standardService.isGrs &&
      (displayAllTabs() || !displayEquipmentTypeFilter())
    " style="display: inline-block;">
    <div class="mcd-filter-dropdown-wrapper">
      <div class="mcd-dropdown-header">
        <div class="dropdown-trigger-btn" role="button" tabindex="0" (click)="toggleDropdown('category')" [style]="isCategoryDropdownOpen || getSelectedItemsCount('category').length > 0 
  ? 'border: 1px solid #6574C4; background: #F8F9FF;' 
  : 'border: 1px solid #DDE1E6;'">
          <span class="trigger-label">Category</span>
          <span class="selected-count-badge" *ngIf="getSelectedItemsCount('category').length > 0">
            {{ getDisplayText('category') }}
          </span>
          <button type="button" class="remove-button" *ngIf="showFilterClearButton('category')"
            (click)="removeSelected('category', $event)" aria-label="Clear category filter">
            <img src="/assets/images/s-remove 1.svg" alt="" />
          </button>
          <span class="trigger-chevron"><img src="/assets/images/down-arrow 1.svg" height="16px" width="16px"
              [style.transform]="isCategoryDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'"
              [style.transition]="'transform 0.3s ease'" /></span>
        </div>
      </div>

      <div class="mcd-dropdown-content" *ngIf="isCategoryDropdownOpen">
        <div class="mcd-dropdown-search">
          <mat-icon class="search-icon">search</mat-icon>

          <input type="text" placeholder="Search" [(ngModel)]="categorySearchText" (input)="filterItems('category')"
            class="search-input" />
        </div>

        <div class="mcd-dropdown-options">
          <ng-container *ngFor="let item of filteredCategories; let i = index">
            <div class="dropdown-option-item">
              <mat-checkbox [checked]="setCheckedStateForCheckBoxes(2, item.id)"
                (change)="addFilter($event, item.id, 2, item.name, 'category')" (click)="$event.stopPropagation()">
                {{ item.name }}
              </mat-checkbox>
            </div>
            <div class="filter-selected-divider" *ngIf="showFilterDivider(filteredCategories, i, 2)"></div>
          </ng-container>
          <div class="no-results" *ngIf="filteredCategories.length === 0">
            No categories found
          </div>
        </div>

        <div class="mcd-dropdown-actions">
          <button mat-button class="apply-btn" (click)="applyFilters()">
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Location Dropdown -->
  <div *ngIf="!standardService.isGrs" style="display: inline-block">
    <div class="mcd-filter-dropdown-wrapper">
      <div class="mcd-dropdown-header">
        <div class="dropdown-trigger-btn" role="button" tabindex="0" (click)="toggleDropdown('location')" [style]="isLocationDropdownOpen || getSelectedItemsCount('location').length > 0 
  ? 'border: 1px solid #6574C4; background: #F8F9FF;' 
  : 'border: 1px solid #DDE1E6;'">
          <span class="trigger-label">Location</span>
          <span class="selected-count-badge" *ngIf="getSelectedItemsCount('location').length > 0">
            {{ getDisplayText('location') }}
          </span>
          <button type="button" class="remove-button" *ngIf="showFilterClearButton('location')"
            (click)="removeSelected('location', $event)" aria-label="Clear location filter">
            <img src="/assets/images/s-remove 1.svg" alt="" />
          </button>
          <span class="trigger-chevron"><img src="/assets/images/down-arrow 1.svg" height="16px" width="16px"
              [style.transform]="isLocationDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'"
              [style.transition]="'transform 0.3s ease'" /></span>
        </div>
      </div>

      <div class="mcd-dropdown-content" *ngIf="isLocationDropdownOpen">
        <div class="mcd-dropdown-search">
          <mat-icon class="search-icon">search</mat-icon>
          <input type="text" placeholder="Search" [(ngModel)]="locationSearchText" (input)="filterItems('location')"
            class="search-input" />
        </div>

        <div class="mcd-dropdown-options">
          <ng-container *ngFor="let item of filteredLocations; let i = index">
            <div class="dropdown-option-item">
              <mat-checkbox [checked]="setCheckedStateForCheckBoxes(1, item.id)"
                (change)="addFilter($event, item.id, 1, item.name, 'location')" (click)="$event.stopPropagation()">
                {{ item.name }}
              </mat-checkbox>
            </div>
            <div class="filter-selected-divider" *ngIf="showFilterDivider(filteredLocations, i, 1)"></div>
          </ng-container>
          <div class="no-results" *ngIf="filteredLocations.length === 0">
            No locations found
          </div>
        </div>

        <div class="mcd-dropdown-actions">
          <button mat-button class="apply-btn" (click)="applyFilters()">
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- country -->

  <div *ngIf="!standardService.isGrs && showCountryFilter()" style="display: inline-block">
    <div class="mcd-filter-dropdown-wrapper">
      <div class="mcd-dropdown-header">
        <div class="dropdown-trigger-btn" role="button" tabindex="0" (click)="toggleDropdown('country')" [style]="
          isCountryDropdownOpen || shouldShowCountryFilterHighlight()
  ? 'border: 1px solid #6574C4; background: #F8F9FF;' 
  : 'border: 1px solid #DDE1E6;'">
          <span class="trigger-label">Country</span>
          <span class="selected-count-badge" *ngIf="getSelectedItemsCount('country').length > 0">
            {{ getDisplayText('country') }}
          </span>
          <button type="button" class="remove-button" *ngIf="showFilterClearButton('country')"
            (click)="removeSelected('country', $event)" aria-label="Clear country filter">
            <img src="/assets/images/s-remove 1.svg" alt="" />
          </button>
          <span class="trigger-chevron"><img src="/assets/images/down-arrow 1.svg" height="16px" width="16px"
              [style.transform]="isCountryDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'"
              [style.transition]="'transform 0.3s ease'" /></span>
        </div>
      </div>

      <div class="mcd-dropdown-content" *ngIf="isCountryDropdownOpen">
        <div class="mcd-dropdown-search">
          <mat-icon class="search-icon">search</mat-icon>
          <input type="text" placeholder="Search" [(ngModel)]="countrySearchText" (input)="filterItems('country')"
            class="search-input" />
        </div>

        <div class="mcd-dropdown-options">
          <ng-container *ngFor="let item of filteredCountries; let i = index">
            <div class="dropdown-option-item">
              <mat-checkbox [checked]="isCountrySelected(item.id)" (change)="onCountryFilterChange($event, item.id)"
                (click)="$event.stopPropagation()">
                {{ item.name }}
              </mat-checkbox>
            </div>
            <div class="filter-selected-divider" *ngIf="showCountryFilterDivider(filteredCountries, i)"></div>
          </ng-container>
          <div class="no-results" *ngIf="filteredCountries.length === 0">
            No countries found
          </div>
        </div>

        <div class="mcd-dropdown-actions">
          <button mat-button class="apply-btn" (click)="applyCountryFilters()">
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>

  <div style="flex: 1;"></div>
  <div>
    <button class="extract-button" (click)="openExportModal()" [disabled]="isExporting">
      <img src="/assets/images/export 1.svg" style="margin-right: 5px" />{{
      isExporting ? "Exporting..." : "Export"
      }}
    </button>
  </div>
</div>

<!-- <div
    *ngIf="
      !standardService.isGrs &&
      (displayAllTabs() || !displayEquipmentTypeFilter())
    "
    class="{{ filtersWidth }}"
  >
    <div class="mcd-filter-tag-wrapper">
      <div class="mcd-tag-title"><button mat-button>Category</button></div>
      
      <mat-checkbox
        *ngFor="let item of categories"
        [checked]="setCheckedStateForCheckBoxes(2, item.id)"
        (change)="addFilter($event, item.id, 2, item.name, 'category')"
        >{{ item.name }}</mat-checkbox
      >
    </div>
  </div> -->

<!-- <div
    *ngIf="!standardService.isGrs"
   
  >
    <div class="mcd-filter-tag-wrapper">
      <div class="mcd-tag-title">Location</div>
      <mat-checkbox
        *ngFor="let item of locationTypes"
        [checked]="setCheckedStateForCheckBoxes(1, item.id)"
        (change)="addFilter($event, item.id, 1, item.name, 'location')"
        >{{ item.name }}</mat-checkbox
      >
    </div>
  </div> -->
<div *ngIf="isExportModalOpen" class="modal-overlay" (click)="closeExportModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Export Standards</h2>
      <button class="close-btn" (click)="closeExportModal()">×</button>
    </div>

    <div class="modal-body">
      <div class="filter-group" *ngIf="!standardService.isGrs">
        <label class="filter-label">Category</label>
        <div class="export-modal-filter-dropdown-wrapper" [style.z-index]="isExportCategoryDropdownOpen ? 30 : 1">
          <div class="export-modal-dropdown-header" (click)="toggleExportDropdown('category')">
            <button class="export-modal-dropdown-trigger-btn buttonArrow" [style]="
                isExportCategoryDropdownOpen ||
                getExportSelectedItemsCount('category').length > 0
                  ? 'border: 1px solid #6574C4; background: #F8F9FF;'
                  : 'border: 1px solid #DDE1E6;'
              " style="display: flex; justify-content: space-between; width: 100%">
              <span class="export-modal-selected-count-badge"
                *ngIf="getExportSelectedItemsCount('category').length > 0">
                {{ getExportDisplayText("category") }}
              </span>
              <span *ngIf="getExportSelectedItemsCount('category').length == 0">
                All
              </span>
              <span>
                <img src="/assets/images/down-arrow 1.svg" height="16px" width="16px" [style.transform]="
                    isExportCategoryDropdownOpen
                      ? 'rotate(180deg)'
                      : 'rotate(0deg)'
                  " [style.transition]="'transform 0.3s ease'" />
              </span>
            </button>
          </div>

          <div class="export-modal-dropdown-content" *ngIf="isExportCategoryDropdownOpen">
            <div class="export-modal-dropdown-options">
              <ng-container *ngFor="let item of exportFilteredCategories; let i = index">
                <div class="export-modal-dropdown-option-item">
                  <mat-checkbox [checked]="setExportCheckedStateForCheckBoxes(2, item.id)" (change)="
                      addExportFilter($event, item.id, 2, item.name, 'category')
                    " (click)="$event.stopPropagation()">
                    {{ item.name }}
                  </mat-checkbox>
                </div>
                <div class="filter-selected-divider" *ngIf="showExportFilterDivider(exportFilteredCategories, i, 2)">
                </div>
              </ng-container>
              <div class="export-modal-no-results" *ngIf="exportFilteredCategories.length === 0">
                No categories found
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="filter-group" *ngIf="!standardService.isGrs">
        <label class="filter-label">Location</label>
        <div class="export-modal-filter-dropdown-wrapper" [style.z-index]="isExportLocationDropdownOpen ? 30 : 1">
          <div class="export-modal-dropdown-header" (click)="toggleExportDropdown('location')">
            <button class="export-modal-dropdown-trigger-btn buttonArrow" [style]="
                isExportLocationDropdownOpen ||
                getExportSelectedItemsCount('location').length > 0
                  ? 'border: 1px solid #6574C4; background: #F8F9FF;'
                  : 'border: 1px solid #DDE1E6;'
              " style="display: flex; justify-content: space-between; width: 100%">
              <span class="export-modal-selected-count-badge"
                *ngIf="getExportSelectedItemsCount('location').length > 0">
                {{ getExportDisplayText("location") }}
              </span>
              <span *ngIf="getExportSelectedItemsCount('location').length == 0">
                All
              </span>
              <span>
                <img src="/assets/images/down-arrow 1.svg" height="16px" width="16px" [style.transform]="
                    isExportLocationDropdownOpen
                      ? 'rotate(180deg)'
                      : 'rotate(0deg)'
                  " [style.transition]="'transform 0.3s ease'" />
              </span>
            </button>
          </div>

          <div class="export-modal-dropdown-content" *ngIf="isExportLocationDropdownOpen">
            <div class="export-modal-dropdown-options">
              <ng-container *ngFor="let item of exportFilteredLocations; let i = index">
                <div class="export-modal-dropdown-option-item">
                  <mat-checkbox [checked]="setExportCheckedStateForCheckBoxes(1, item.id)" (change)="
                      addExportFilter($event, item.id, 1, item.name, 'location')
                    " (click)="$event.stopPropagation()">
                    {{ item.name }}
                  </mat-checkbox>
                </div>
                <div class="filter-selected-divider" *ngIf="showExportFilterDivider(exportFilteredLocations, i, 1)">
                </div>
              </ng-container>
              <div class="export-modal-no-results" *ngIf="exportFilteredLocations.length === 0">
                No locations found
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="filter-group" *ngIf="showCountryFilter()">
        <label class="filter-label">Country</label>
        <div class="export-modal-filter-dropdown-wrapper" [style.z-index]="isExportCountryDropdownOpen ? 30 : 1">
          <div class="export-modal-dropdown-header" (click)="toggleExportDropdown('country')">
            <button class="export-modal-dropdown-trigger-btn buttonArrow" [style]="
                isExportCountryDropdownOpen ||
                ExportselectedCountryIds.length > 0
                  ? 'border: 1px solid #6574C4; background: #F8F9FF;'
                  : 'border: 1px solid #DDE1E6;'
              " style="display: flex; justify-content: space-between; width: 100%">
              <span class="export-modal-selected-count-badge" *ngIf="ExportselectedCountryIds.length > 0">
                {{ getExportCountryDisplayText() }}
              </span>
              <span *ngIf="ExportselectedCountryIds.length == 0">All</span>
              <span>
                <img src="/assets/images/down-arrow 1.svg" height="16px" width="16px" [style.transform]="
                    isExportCountryDropdownOpen
                      ? 'rotate(180deg)'
                      : 'rotate(0deg)'
                  " [style.transition]="'transform 0.3s ease'" />
              </span>
            </button>
          </div>

          <div class="export-modal-dropdown-content" *ngIf="isExportCountryDropdownOpen">
            <div class="export-modal-dropdown-options">
              <ng-container *ngFor="let item of exportFilteredCountries; let i = index">
                <div class="export-modal-dropdown-option-item">
                  <mat-checkbox [checked]="isExportCountrySelected(item.id)"
                    (change)="onExportCountrySelectionChange($event, item.id)" (click)="$event.stopPropagation()">
                    {{ item.name }}
                  </mat-checkbox>
                </div>
                <div class="filter-selected-divider" *ngIf="showExportCountryFilterDivider(exportFilteredCountries, i)">
                </div>
              </ng-container>
              <div class="export-modal-no-results" *ngIf="exportFilteredCountries.length === 0">
                No countries found
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="export-modal-footer">
      <button class="export-modal-cancel-btn" (click)="closeExportModal()">
        Cancel
      </button>
      <button class="export-modal-export-btn" (click)="applyExportFilters()" [disabled]="isExporting">
        <img src="/assets/images/export-black.svg" style="
            margin-bottom: 2px;
            margin-right: 4px;
            height: 12px;
            width: 12px;
          " />{{ isExporting ? "Exporting..." : "Export" }}
      </button>
    </div>
  </div>
</div>

<!-- <div
  *ngIf="
    !standardService.isGrs && (displayAllTabs() || displayEquipmentTypeFilter())
  "
  class="{{ filtersWidth }} last-filter-wrapper"
>
  <div class="mcd-filter-tag-wrapper">
    <div class="mcd-tag-title">Equipment Type</div>
    <mat-checkbox
      *ngFor="let item of equipmentTypes"
      [checked]="setCheckedStateForCheckBoxes(4, item.id)"
      (change)="addFilter($event, item.id, 4, item.name, 'equipmentType')"
      >{{ item.name }}</mat-checkbox
    >
  </div>
</div> -->